import { Component, OnInit, Input, ChangeDetectorRef } from '@angular/core';
import { ProductInformation } from '../../../../../shared/objects/transport-information/product-information';
import { NgbActiveModal } from '../../../../../../../node_modules/@ng-bootstrap/ng-bootstrap';
import { ContainerService } from '../../shared/container.service';
import { TranslateService } from '@ngx-translate/core';
import { TransportInformationTemplate } from '../../../../../shared/objects/transport-information/transport-information-template';
import {
  FormBuilder,
  FormGroup,
  FormControl,
  Validators,
} from '@angular/forms';
import { PreviousProductField } from '../../../../../shared/objects/enum/previousProductField';
import { CommonUtils } from '../../../../../shared/utils/common.utils';

@Component({
    selector: 'app-container-compartment',
    templateUrl: './container-compartment.component.html',
    styleUrls: ['./container-compartment.component.css'],
    standalone: false
})
export class ContainerCompartmentComponent implements OnInit {
  @Input() editMode: boolean;
  @Input() compartment: ProductInformation;
  @Input() nextCompartmentNumber: number;
  @Input() template: TransportInformationTemplate;

  previousProductsNumber = 0;
  containerCompartmentForm: FormGroup;

  constructor(
    public activeModal: NgbActiveModal,
    public containerService: ContainerService,
    private translateService: TranslateService,
    private fb: FormBuilder,
  ) {
    this.containerCompartmentForm = this.fb.group({});
  }

  ngOnInit() {
    this.template?.fields.forEach(element => {
      if (element.available) {
        if (this.isCompartmentField(element.fieldType)) {
          if (element.mandatory) {
            this.containerCompartmentForm.addControl(
              PreviousProductField[element.fieldType],
              new FormControl('', [Validators.required]),
            );
          } else {
            this.containerCompartmentForm.addControl(
              PreviousProductField[element.fieldType],
              new FormControl(''),
            );
          }
        }

        if (
          element.fieldType === PreviousProductField.NumberOfPreviousProducts
        ) {
          this.previousProductsNumber = element.cardinal;
          this.addProductsToForm(element.mandatory);
        }

        if (element.fieldType === PreviousProductField.IDTF) {
          this.addIDTFToForm(element.mandatory);
        }
      }
    });
    if (!this.editMode) {
      this.compartment = new ProductInformation();
    }
  }

  addProductsToForm(mandatory: boolean) {
    for (
      let productNumber = 0;
      productNumber < this.previousProductsNumber;
      productNumber++
    ) {
      const product = productNumber + 1;
      if (mandatory) {
        this.containerCompartmentForm.addControl(
          'PreviousProduct' + product.toString(),
          new FormControl('', [Validators.required]),
        );
      } else {
        this.containerCompartmentForm.addControl(
          'PreviousProduct' + product.toString(),
          new FormControl(''),
        );
      }
    }
  }

  addIDTFToForm(mandatory: boolean) {
    for (
      let productNumber = 0;
      productNumber < this.previousProductsNumber;
      productNumber++
    ) {
      const product = productNumber + 1;
      if (mandatory) {
        this.containerCompartmentForm.addControl(
          'IDTF' + product.toString(),
          new FormControl('', [Validators.required]),
        );
      } else {
        this.containerCompartmentForm.addControl(
          'IDTF' + product.toString(),
          new FormControl(''),
        );
      }
    }
  }

  isCompartmentField(fieldType: number) {
    if (fieldType === PreviousProductField.SizeOfCompartments) {
      return true;
    }
    return false;
  }

  markFormTouched(form: any) {
    CommonUtils.markFormAsTouched(form);
  }

  confirmAction() {
    if (!this.containerCompartmentForm.valid) {
      this.markFormTouched(this.containerCompartmentForm);
      return;
    }
    if (!this.editMode) {
      this.compartment.compartmentNumber = this.nextCompartmentNumber;
    }
    this.activeModal.close(this.compartment);
  }

  getOperationDescription(): string {
    let actionText;
    if (this.editMode) {
      this.translateService
        .get('SHARED.UPDATE-BUTTON')
        .subscribe(t => (actionText = t));
    } else {
      this.translateService
        .get('SHARED.ADD-BUTTON')
        .subscribe(t => (actionText = t));
    }
    return actionText;
  }
}
